import { render, staticRenderFns } from "./CustomerHubActivityRows.vue?vue&type=template&id=45797bc4&scoped=true"
import script from "./CustomerHubActivityRows.vue?vue&type=script&lang=js"
export * from "./CustomerHubActivityRows.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubActivityRows.vue?vue&type=style&index=0&id=45797bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45797bc4",
  null
  
)

export default component.exports